import React from "react";
import { Link } from 'react-router-dom';
import Navbar from "../components/Navbar";
import BottomContent from "../components/BottomContent";
import ScrollButton from "../components/ScrollButton";
import Thank from "../components/Thank";
import DarkModeButton from "../components/DarkModeButton";
import ContactButton from "../components/ContactButton";
import HeroImg from '../assets/img/ServiceImg.png';
import Hero from '../features/Hero';
import "./Service.css";

export default function Service() {
  const services = [
    {
      imageURL: "media/img/DigitalImg.png",
      serviceName: "Digital",
      serviceDescription: "Leverage cutting-edge digital innovation to transform your business. Our services include digital strategy, creative and emerging engineering, AI automation practices (RPA/CPA), AI data science practices (DS/ML/DL, GenAI), quantum computing, cybersecurity, chatbot solutions, and blockchain & IoT practices.",
      link: "/digital",
      point: "Empowering Innovation through Advanced Digital Solutions",
    },
    {
      imageURL: "media/img/ConsultingImg.png",
      serviceName: "Advisory & Consulting",
      serviceDescription: "Vedalytics provides comprehensive advisory and consulting services to drive enterprise transformation and innovation. From strategy and architecture to data governance and innovation management, we offer solutions tailored to diverse business sectors, including education and healthcare.",
      link: "/consulting",
      point: "Guiding Business Success through Strategic Expertise",
    },
    {
      imageURL: "media/img/TechnologyImg.png",
      serviceName: "Technology",
      serviceDescription: "Achieve digital excellence with our technology services, including Agile lifecycle management, DevOps transformation, cloud and microservices adoption, API development, quality assurance, intelligent automation (RPA/CPA), and application development (.Net, Java, PWA, Big Data, GenAI). Our zero-maintenance, auto-heal IT support ensures smooth operations.",
      link: "/technology",
      point: "Driving Efficiency with Modern Technology Solutions",
    },
  ];

  

  return (
    <>
      <Navbar />
      {/* Hero Section */}
      <Hero
            heading='Our Services'
            subheading='Transform your business with Vedalytics'
            des='We offer project services where we take full responsibility of deliverables using Build-Operate-Transfer & Managed models Focus and Adoption of emerging tools & technologies.'
            img={HeroImg}
      />

        {/* Service Section */}
        <div className="container mt-5 mb-5">
        {services.map((service, index) => (
          <div className="row align-items-center py-4 mb-5" key={index}>
            {/* Image */}
            <div className={`col-12 col-md-6 d-flex justify-content-center ${index % 2 === 0 ? "order-1 order-md-1" : "order-1 order-md-2"}`}>
              <img
                className="img-fluid"
                loading='lazy'
                src={service.imageURL}
                alt={service.serviceName}
                style={{ maxWidth: "400px", maxHeight: "400px", width: "100%", height: "auto" }}
              />
            </div>

            {/* Text */}
            <div className={`col-12 col-md-6 text-center text-md-start ${index % 2 === 0 ? "order-2 order-md-2" : "order-2 order-md-1"}`}>
              <h2 style={{ color: "var(--heading_color)", marginTop: '10px' }}>{service.serviceName}</h2>
              <h6 style={{ color: "var(--heading_color)" }}>{service.point}</h6>
              <p className="fs-5 text-muted">{service.serviceDescription}</p>
              <Link to={service.link} className="fs-5 text-decoration-none btn btn-outline-primary mt-2">
                Learn More <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        ))}
      </div>
      <Thank />
      <BottomContent />
      <ContactButton />
      <DarkModeButton />
      <ScrollButton />
    </>
  );
}
